import { RouteConfig } from 'vue-router';

import { EntityType } from '@/enums/entityType.enum';
import { Options } from '@/enums/options.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { TableName } from '@/enums/tableName';
import { Document } from '@/interfaces/document';
import { DocumentIndex } from '@/interfaces/documentIndex';
import store from '@/store/store';
import { getProfileId } from '@/utils/profile';

export const documentAssessmentRoute: RouteConfig = {
  name: 'documentAssessment',
  path: 'assessment',
  component: () => import(/* webpackChunkName: "DocumentAssesment" */ '@/views/mainRoute/document/Assessment.vue'),
  meta: { breadcrumb: { title: 'Ocena' } },
  beforeEnter: (to, from, next) => {
    store.commit('document/setId', parseInt(to.params.documentId));
    store.commit('documentIndex/setId', parseInt(to.params.documentId));
    Promise.all([store.dispatch('document/get'), store.dispatch('documentIndex/get')])
      .then(([document, indexedDocument]: [Document, DocumentIndex]) => {
        const statusId = document.statusId;
        const stageId = document.status.stageId;
        const previousStatusId = indexedDocument.previousStatuses[0];
        return Promise.all([
          store.dispatch('criterion/list', { statusId, count: -1, order: 'order', desc: false }).then(() => {
            if (!store.state.criterion.list || !store.state.criterion.list.length) {
              return store.dispatch('criterion/list', { stageId });
            }
          }),
          store.dispatch('assessment/list', {
            stageId,
            profileId: getProfileId(),
            documentId: document.id
          }),
          store.dispatch('optionValue/getByCode', {
            code: Options.DICTIONARY,
            entityType: TableName.status,
            entityId: previousStatusId.toString()
          }),
          store
            .dispatch('optionValue/getByCode', {
              code: Options.SCHEMA_ID,
              entityType: TableName.status,
              entityId: previousStatusId.toString()
            })
            .then(result => store.dispatch('schema/get', parseInt(result.value))),
          store.dispatch('setting/findPublic', {
            code: PublicSettings.DOCUMENT_VIEW_ID,
            entityType: EntityType.PROCEDURE,
            entityId: to.params.procedureId.toString()
          })
        ]);
      })
      .then(() => next());
  }
};
